import { Pipe, PipeTransform } from '@angular/core';
import { TracklinePlanningDay } from './trackline-planning-day';

@Pipe({
    name: 'dayEntityTypeFilter',
})
export class DayEntityTypeFilterPipe implements PipeTransform {
    transform(
        day: TracklinePlanningDay,
        entityTypes: string[],
        projectManagerId?: number | null
    ): TracklinePlanningDay {
        return {
            ...day,
            items: day.items.filter(
                item =>
                    (!entityTypes?.length || entityTypes.includes(item.mainPlanning.entitytype_key)) &&
                    (projectManagerId == null || item.projectmanager === projectManagerId)
            ),
        };
    }
}
